import axios from "axios";
import { eventBus } from "@/main";

const modulePayment = {
  namespaced: true,
  state: {
    transactionDetails: null,
    transactionDetailsLoading: false,
    transactionDetailsError: null,
  },
  getters: {
    getTransactionDetails: state => state.transactionDetails,
    getTransactionDetailsLoading: state => state.transactionDetailsLoading,
    getTransactionDetailsError: state => state.transactionDetailsError,
  },
  mutations: {
    SET_TRANSACTION_DETAILS(state, data) {
      state.transactionDetails = data;
    },
    SET_TRANSACTION_DETAILS_LOADING(state, loading) {
      state.transactionDetailsLoading = loading;
    },
    SET_TRANSACTION_DETAILS_ERROR(state, error) {
      state.transactionDetailsError = error;
    },
  },
  actions: {
    async fetchTransactionDetails({ commit }, { clinicUrl, branchUrl, referenceId }) {
      commit("SET_TRANSACTION_DETAILS_LOADING", true);
      commit("SET_TRANSACTION_DETAILS_ERROR", null);
      commit("SET_TRANSACTION_DETAILS", null);

      try {
        if (!clinicUrl || !branchUrl || !referenceId) {
          throw new Error("ข้อมูลไม่ครบถ้วน ไม่สามารถดึงข้อมูลการทำรายการได้");
        }

        const response = await axios.get(`/api/ktb-fastpay/transaction/${clinicUrl}/${branchUrl}/${referenceId}`);

        if (response.data) {
          commit("SET_TRANSACTION_DETAILS", response.data);
          return response.data;
        } else {
          throw new Error("ไม่พบข้อมูลการทำรายการ");
        }
      } catch (error) {
        let errorMessage = "ไม่สามารถดึงข้อมูลการทำรายการได้";
        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        } else if (error.message) {
          errorMessage = error.message;
        }

        commit("SET_TRANSACTION_DETAILS_ERROR", errorMessage);
        throw error;
      } finally {
        commit("SET_TRANSACTION_DETAILS_LOADING", false);
      }
    }
  }
};

export default modulePayment;